import TemplateData from '../../utility/getTemplateData';
import {
  formatCurrency,
  formatCurrencyAsString,
  normalizeNumber,
  getGriffin,
} from '../../utility/formator';
import _get from 'lodash/get';

export const MIN_INPUT_WIDTH = 105;
export const DEFAULT_INPUT_FONTSIZE = 55;

/**
 * This is a copy of the function "formatAmountFromServer" from
 * "public/js/buttons/utils/amountUtils.js"
 */
export function formatAmountFromServerDNW(value, currency) {
  let griffin = getGriffin();
  const digits = _get(griffin, `metadata.currencyInfo[${currency}].digits`);
  const negativeDigits = `-${digits}`;

  if (value.indexOf('.') < 0) {
    if (digits === 2) {
      value = `${value}.00`;
    }
    if (digits === 1) {
      value = `${value}.0`;
    }
  } else {
    const digitsAfterDecimalPoint = value.split('.')[1].length;
    if (digitsAfterDecimalPoint === 1 && digits === 2) {
      value = `${value}0`;
    }
  }

  value = value.replace(/[^0-9]/g, '') || 0;
  value = parseInt(value, 10).toString();

  if (value.length === 1) {
    value = `00${value}`;
  } else if (value.length === 2) {
    value = `0${value}`;
  }
  // else if (value.length > MAX_AMOUNT_LENGTH) {
  // 	value = value.substr(0, MAX_AMOUNT_LENGTH);
  // }

  // Some currencies (eg: JPY) do not have decimal points
  if (digits > 0) {
    value = `${value.slice(0, negativeDigits)}.${value.slice(negativeDigits)}`;
  }

  return formatCurrency({ value, currency });
}

export function formatAmount(value = '', currency) {
  value = value.replace(/[^0-9]/g, '') || 0;
  value = parseInt(value, 10).toString();

  if (value.length === 1) {
    value = `00${value}`;
  } else if (value.length === 2) {
    value = `0${value}`;
  }

  let griffin = getGriffin();
  const digits = _get(
    griffin,
    `metadata.currencyInfo[${TemplateData.donationCode}].digits`
  );
  const negativeDigits = `-${digits}`;

  // Some currencies (eg: JPY) do not have decimal points
  if (digits > 0) {
    value = `${value.slice(0, negativeDigits)}.${value.slice(negativeDigits)}`;
  }

  return formatCurrency({ value, currency });
}

export function amountLengthValid(value = '') {
  const val = value.replace(/[^0-9]/g, '') || 0;

  if (val.length > 9) {
    return false;
  }
  return true;
}

const allowedKeys = [16, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
export function isKeyAllowed(keyCode) {
  return allowedKeys.indexOf(keyCode) > -1;
}

export function getMinimumDonationErrorMessage(messages) {
  const formattedDollarOne = formatCurrencyAsString({
    value: 1,
    currency: 'USD',
  });

  let errorMessage = TemplateData.enablePresetAmounts
    ? messages.error.minimumDonationUSShort
    : messages.error.minimumDonationUS;

  errorMessage = errorMessage.replace('{amount}', formattedDollarOne);
  return errorMessage;
}

export function isAmountGreaterThanZero(amount) {
  const normalizedDonationAmount = getNormalizedNumber(amount);
  return normalizedDonationAmount > 0;
}

/**
 * Returns griffin-normalized number or zero
 */
export function getNormalizedNumber(amount) {
  try {
    if (!amount) {
      return 0;
    }

    const normalizedNumber = normalizeNumber(amount);

    if (typeof normalizedNumber !== 'number' && normalizedNumber.errors) {
      return 0;
    }

    return normalizedNumber;
  } catch (e) {
    return 0;
  }
}

/**
 * Gets the width of the input field
 * @param  {HTMLElement} input The input element
 * @param  {String} text Value of the input element
 * @return {Number}      Width of the input element
 */
export function getInputWidth(field, text) {
  text = text || '0.00';

  // Get styles from the element
  const currentStyles = window.getComputedStyle(field) || {};
  let { fontWeight } = currentStyles;
  let fontSize = `${getFontSize(text)}px`;

  // Create a span element outside visible area
  const spanElem = document.createElement('span');
  spanElem.style.fontSize = fontSize;
  spanElem.style.fontFamily = 'PayPalSansBig-Light';
  spanElem.style.fontWeight = fontWeight || '200';
  spanElem.style.position = 'fixed';
  spanElem.style.top = '-1000px';
  spanElem.style.left = '-1000px';
  spanElem.innerHTML = text;
  document.body.appendChild(spanElem);

  // Get width of the span and then remove it
  const width = spanElem.getBoundingClientRect().width + 2; // increase by 2px to fix a layout problem in Safari iOS browser.
  document.body.removeChild(spanElem);

  if (width < MIN_INPUT_WIDTH) {
    return MIN_INPUT_WIDTH;
  }
  return width;
}

const DIGITS_TO_FONT_SIZE_MAPPING = {
  6: 55,
  7: 47,
  8: 42,
  9: 40,
  10: 38,
};
export function getFontSize(value) {
  let digitCount = value.replace(/[\.,]/g, '').length;

  if (digitCount < 6) {
    return DEFAULT_INPUT_FONTSIZE;
  }

  return DIGITS_TO_FONT_SIZE_MAPPING[`${digitCount}`] || 55;
}
